import React from 'react';

import { Button, Paper, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

export interface SelectionAction {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  disabledReason?: string;
}

interface Props {
  selectedCount: number;
  itemNoun: string;
  /** Pairs each selected row stands for, so the bar can say what the action will actually touch. */
  summary: string;
  actions: Array<SelectionAction>;
  onClear: () => void;
}

export default function SelectionActionBar({ selectedCount, itemNoun, summary, actions, onClear }: Props) {
  if (!selectedCount) {
    return null;
  }

  return (
    <Paper
      variant="outlined"
      sx={{ p: 1.5, bgcolor: (theme) => alpha(theme.palette.primary.main, 0.06), borderColor: 'primary.light' }}
    >
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ sm: 'center' }}>
        <Stack flex={1} minWidth={0}>
          <Typography variant="body2" fontWeight={600}>
            {selectedCount.toLocaleString()} {itemNoun}
            {selectedCount === 1 ? '' : 's'} selected
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {summary}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} flexWrap="wrap">
          {actions.map((action) => (
            <Button
              key={action.label}
              size="small"
              variant="contained"
              color="primary"
              disabled={action.disabled}
              title={action.disabled ? action.disabledReason : undefined}
              onClick={action.onClick}
            >
              {action.label}
            </Button>
          ))}
          <Button size="small" variant="text" onClick={onClear}>
            Clear
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
}
